(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/accept-terms-checkbox.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/accept-terms-checkbox.js');
"use strict";


const {
  Checkbox,
  ControlGroup,
  FormContext
} = svs.ui.reactForm;
const {
  TERMS_AND_CONDITIONS
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  LABEL,
  LINK_TEXT
} = svs.ticket_partner.sharedComponents.input.constants.TEXTS.TERMS_AND_CONDITIONS;
const {
  showTermsDialog
} = svs.ticket_partner.utils;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const AcceptTerms = _ref => {
  let {
    handleOnChange,
    state
  } = _ref;
  const validate = (event, value) => {
    let currentErrorMessage;
    const isValid = value === 'true' || value === true;
    if (!isValid) {
      currentErrorMessage = 'Du måste acceptera villkoren.';
    }
    return {
      errorMessage: currentErrorMessage,
      isValid,
      name: TERMS_AND_CONDITIONS
    };
  };
  const handleOnClick = e => {
    e.preventDefault();
    showTermsDialog();
  };
  return React.createElement(FormContext.Consumer, null, _ref2 => {
    let {
      form,
      register,
      handleChange
    } = _ref2;
    return React.createElement(ControlGroup, {
      errorMessage: form[TERMS_AND_CONDITIONS] && form[TERMS_AND_CONDITIONS].errorMessage,
      hasError: form[TERMS_AND_CONDITIONS] && !form[TERMS_AND_CONDITIONS].isValid,
      v2: true
    }, React.createElement(Checkbox, {
      checked: state[TERMS_AND_CONDITIONS],
      id: TERMS_AND_CONDITIONS,
      name: TERMS_AND_CONDITIONS,
      onChange: e => {
        handleChange({
          target: {
            name: TERMS_AND_CONDITIONS,
            value: state[TERMS_AND_CONDITIONS]
          }
        });
        handleOnChange(e);
      },
      required: true
    }, LABEL), React.createElement(IconButton, {
      onClick: handleOnClick
    }, React.createElement(Icon, {
      className: "margin-right-half",
      icon: "information"
    }), React.createElement("a", null, LINK_TEXT)), React.createElement("input", {
      hidden: true,
      readOnly: true,
      ref: register(TERMS_AND_CONDITIONS, validate),
      value: state[TERMS_AND_CONDITIONS]
    }));
  });
};
svs.ticket_partner.sharedComponents.input.AcceptTerms = AcceptTerms;

 })(window);